import React, { Component } from "react"
import { connect } from 'react-redux'
import { saveTransactionAction } from '../../redux/actions/MainAction'
import {
    getAssetAction,
    getCostCenterAction,
    getGLAccountAction
}
    from '../../redux/actions/MasterAction'

class AccountAssignModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props,
            assets: [],
            gl_accounts : [],
            cost_centers : []
        }

        this.handleChange = this.handleChange.bind(this)
    }

    async handleChange(event) {
        await this.props.updateTransaction(this.state.transaction)
    }

    componentDidMount(){
        this.props.getAsset().then((response)=>{
            this.setState({assets:response.data})
        })

        this.props.getCostCenter().then((response)=>{
            this.setState({cost_centers : response.data})
        })

        this.props.getGLAccount().then((response)=>{
            this.setState({gl_accounts : response.data})
        })
    }

    render() {
        console.log("AccountAssignModal.render()")

        let {assets,gl_accounts,cost_centers}=this.state

        return (
            <div className="modal fade sp-modal rrs-modal" id="accountAssignModal" tabIndex={-1} role="dialog" aria-labelledby="accountAssignModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="accountAssignModalLabel">Account Assignment</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="rrs-detail-data sp-table-container">
                                <div className="row align-items-center account-assign-modal-top mx-0">
                                    <div className="col-md-6 col-lg-4 pr-md-5 pl-0">
                                        Purchase Order PO / Contract Number : 4110009455
                                        </div>
                                    <div className="col-md-6 col-lg-4">
                                        <div className="form-inline">
                                            <div className="col-auto pl-0"><label className="rrs-detail-label mb-md-0" htmlFor="sp-input1">Item Number</label></div>
                                            <div className="rrs-detail-data">
                                                <select className="js-select2 rrs-js-select2" name="sp-input1">
                                                    <option value={0}>Please Select Number</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-lg-4 pr-md-5">
                                        <div className="rrs-form">
                                            <label htmlFor="cc" className="rrs-label">AccAssCat</label>
                                            <div className="rrs-detail-data">
                                                <select className="js-select2 rrs-js-select2" name="sp-input1">
                                                    <option value={0}>A Asset</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-lg-4">
                                        <label className="rrs-detail-label" htmlFor="sp-input1">Distribution</label>
                                        <div className="rrs-detail-data">
                                            <select className="js-select2 rrs-js-select2" name="sp-input1">
                                                <option value={0}>Distrib, on quantity basic</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="row no-gutters sp-table-content">
                                    <div className="row rrs-table-hdr-wrap">
                                        <div className="col"><h2 className="rrs-table-hdr">Item Text: รายการจ้างงานบริการ</h2></div>
                                    </div>
                                    <table className="sp-table table rrs-table">
                                        <thead>
                                            <tr className="sp-table-header">
                                                <th className="th-table"><div className="th-text">Seq.</div></th>
                                                <th className="th-table"><div className="th-text">Quantity</div></th>
                                                <th className="th-table"><div className="th-text">Perce</div></th>
                                                <th className="th-table"><div className="th-text">G/L Acct</div></th>
                                                <th className="th-table"><div className="th-text">Cost Center</div></th>
                                                <th className="th-table"><div className="th-text">Asset</div></th>
                                                <th className="th-table"><div className="th-text">Order</div></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name="transaction.invoice.items#0.service_lines#0.unplanned_quantity"
                                                        className="form-control"
                                                        id="unplanned_quantity"
                                                        onBlur={this.handleChange}
                                                    />
                                                </td>
                                                <td>1.0</td>
                                                <td>
                                                    <select name="gl_account" id="gl_account" value={""} onChange={this.handleChange} className="js-select2">
                                                        {gl_accounts.map((glAccount, index) => (
                                                            <option key={index} value={glAccount.GL_ACCOUNT_NO}>{glAccount.SHORT_TEXT}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                                <td>
                                                    <select name="cost_center" id="cost_center" value={""} onChange={this.handleChange} className="js-select2">
                                                        {cost_centers.map((costCenter, index) => (
                                                            <option key={index} value={costCenter.COST_CENTER}>{costCenter.GENERAL_NAME}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                                <td>
                                                    <select name="asset" id="asset" value={""} onChange={this.handleChange} className="js-select2">
                                                        {assets.map((asset, index) => (
                                                            <option key={index} value={asset.MAIN_ASSET_NUMBER}>{asset.MAIN_ASSET_NUMBER}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                                <td>
                                                    <select name="select4" id="select4" className="js-select2">
                                                        <option value="123-901-001">123-901-001</option>
                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row mx-0 header-button-row mt-5">
                                    <div className="col-12 sp-header-button-panel2">
                                        <a href="#" className="sp-btn-icon">
                                            <i className="icon btn-order-savedraft" />
                                            <span className="sp-btn-icon-label">Save</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const {  MainRedux } = state
    return {
        transaction: MainRedux.transaction
    }
}

const mapDispatchToProps = dispatch => {
    return {
        saveTransaction: (transaction) => dispatch(saveTransactionAction(transaction)),
        getAsset: () => dispatch(getAssetAction()),
        getCostCenter: () => dispatch(getCostCenterAction(null,null,null)),
        getGLAccount: () => dispatch(getGLAccountAction(null,null,null)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AccountAssignModal)